<script>
import NavBarRoutes from './nav-bar-routes.vue'

export default {
  components: { NavBarRoutes },
  data() {
    return {
      persistentNavRoutes: [
        {
          name: 'home',
          title: 'Main',
        },
      ],
      academyNavRoutes: [
        {
          name: 'academy',
          title: 'Academy',
        },
      ],
      middleGalaxyNavRoutes: [
        {
          name: 'middleGalaxy',
          title: 'Middle Galaxy',
        },
      ],
      mapMyGradNavRoutes: [
        {
          name: 'mapMyGrad',
          title: 'Map My Grad',
        },
      ],
      dataVizNavRoutes: [
        {
          name: 'dataViz',
          title: 'Data Viz',
        },
      ],
    }
  },
}
</script>

<template>
  <ul :class="$style.container">
    <NavBarRoutes :routes="persistentNavRoutes"/>
    <NavBarRoutes :routes="academyNavRoutes"/>
    <NavBarRoutes :routes="middleGalaxyNavRoutes"/>
    <NavBarRoutes :routes="mapMyGradNavRoutes"/>
    <NavBarRoutes :routes="dataVizNavRoutes"/>
  </ul>
</template>

<style lang="scss" module>
@import '@design';

.container {
  padding: $size-grid-padding 0 $size-grid-padding 0;
  margin: 0;
  text-align: center;
  list-style-type: none;

  > li {
    padding-right: 45px;
    display: inline-block;
    margin-right: $size-grid-padding;
  }
}
</style>

<style scoped>
ul {
  background-color: white;
  border-bottom: 1px solid #e6e6e6;
}
</style>
